import { render, staticRenderFns } from "./Banner_mobile.vue?vue&type=template&id=b6c0fe06&"
import script from "./Banner_mobile.vue?vue&type=script&lang=js&"
export * from "./Banner_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Banner_mobile.vue?vue&type=style&index=0&id=b6c0fe06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports